import {takeLatest, put, call} from 'redux-saga/effects';
import apiCall from '../../api';
import {DELETE_NATURE_MAGAZINE_ERROR, DELETE_NATURE_MAGAZINE_START, DELETE_NATURE_MAGAZINE_SUCCESS} from "../../types";

export function* deleteNMagazine({payload}) {
    try {
        const url = `/natura_magazines/${payload.id}/`;
        const method = 'DELETE';
        const headers = {Authorization: 'Bearer ' + payload.token, 'Content-Type':'application/json'};
        const results = yield call(apiCall, url, method, payload.formData, headers);
        yield put({type: DELETE_NATURE_MAGAZINE_SUCCESS, results: results.data});
    } catch (error) {
        yield put({type: DELETE_NATURE_MAGAZINE_ERROR, error});
    }
}

export default function* delete_nature_magazine() {
    yield takeLatest(DELETE_NATURE_MAGAZINE_START, deleteNMagazine);
}